import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { apiFetch } from "@/lib/api.js";
import { useAuth } from "@/auth/useAuth.js";

const PortalReadiness = z.object({
  key: z.string(),
  name: z.string(),
  format: z.string(),
  foreign: z.boolean(),
  note: z.string(),
  feed_path: z.string(),
  total: z.number(),
  ready: z.number(),
  missing: z.number(),
  incomplete: z.array(z.object({
    id: z.string(),
    slug: z.string(),
    title: z.string(),
    missing: z.array(z.string()),
  })),
});
export type PortalReadiness = z.infer<typeof PortalReadiness>;

const ReadinessResponse = z.object({
  published: z.number(),
  portals: z.array(PortalReadiness),
});

export function usePortalReadiness() {
  const { session } = useAuth();
  const token = session?.access_token;
  return useQuery({
    queryKey: ["portals", "readiness"],
    enabled: !!token,
    queryFn: () => apiFetch("/api/v1/admin/portals/readiness", token!, ReadinessResponse),
  });
}
